import PropTypes from 'prop-types';
import React from 'react';

import { propTypesLocalization } from '../../../../shared/constants/Proptypes';
import { propTypesAuthor } from '../../../Post/Post.proptypes';

import Avatar from '../../../../ui/Atoms/Avatar';
import Tag from '../../../../ui/Atoms/Tag';
import Text, { TextAppearance } from '../../../../ui/Atoms/Text';

import { getStaticUrl } from '../../../../shared/utils/getStaticUrl';

import * as S from './PostFooter.styles';

export const PostFooter = ({ author, localization, tags }) => {
  if (!localization) {
    return null;
  }

  const {
    profile_picture: { alt, localFile } = {},
    description: { html: authorBio } = {},
    first_name: firstName,
    last_name: lastName,
  } = author || '';

  const avatarProps = {
    imageUrl: getStaticUrl(localFile?.publicURL),
    altText: alt,
  };

  const {
    data: {
      tag_section_label: tagsLabel,
      author_section_label: authorLabel,
    } = {},
  } = localization || '';

  const styledTagsLabel = tagsLabel || null;
  const styledAuthorLabel = authorLabel || null;
  const authorName = firstName
    ? `${firstName} ${lastName ? ` ${lastName}` : ''}`
    : null;

  const hasTag = tags?.length > 0;

  return (
    <S.PostFooter>
      {firstName && lastName && (
        <S.AuthorSection>
          <S.Label>{styledAuthorLabel}</S.Label>
          <S.AuthorContent>
            <Avatar {...avatarProps} />
            <S.AuthorDescription>
              <S.Label>{authorName}</S.Label>
              <Text type={TextAppearance.AUTHOR}>{authorBio}</Text>
            </S.AuthorDescription>
          </S.AuthorContent>
        </S.AuthorSection>
      )}
      {hasTag && (
        <S.TagSection>
          <S.Label>{styledTagsLabel}</S.Label>
          <S.Tags>
            {tags.map((tag, index) => (
              <Tag key={`${tag}-${index}`} link={tag.uid}>
                {tag.name}
              </Tag>
            ))}
          </S.Tags>
        </S.TagSection>
      )}
    </S.PostFooter>
  );
};

PostFooter.propTypes = {
  /**
   * Author from the current Post.
   */
  author: PropTypes.shape(propTypesAuthor),
  /**
   * Localization document.
   */
  localization: PropTypes.shape(propTypesLocalization),
  /**
   * Tag list from the current Post.
   */
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      uid: PropTypes.string,
    })
  ),
};
